import * as THREE from 'three';
import { Line2 } from 'three/addons/lines/Line2.js';
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';
import { LineGeometry } from 'three/addons/lines/LineGeometry.js';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { pixelRatio2d } from '@/editor/math/const';
import { disposeAllChildrenThenRemoveFromParent } from '../utils';
import { ENTITY_LATER, ENTITY_RENDER_ORDER, defaultOutlineColor } from '@/editor/constant/entity';
import { EContainerType } from '@/editor/types/entity';
import { EEntityType } from '@/editor/types';

class HighlightedLine {
  private _highlightedLine: Line2;

  constructor(points: IPoint2d[], renderOrder: number = ENTITY_RENDER_ORDER.highlightedLine, linewidth = 0.5) {
    const lineGeometry = new LineGeometry();
    lineGeometry.setPositions(points.flatMap((p) => [p.x / pixelRatio2d, p.y / pixelRatio2d, 0]));
    const lineMaterial = new LineMaterial({
      color: defaultOutlineColor,
      depthTest: true, // 不进行深度测试
      transparent: true,
      linewidth // 宽度（需启用渲染器支持）
    });

    this._highlightedLine = new Line2(lineGeometry, lineMaterial);
    this._highlightedLine.renderOrder = renderOrder;
    this._highlightedLine.userData.type = EEntityType.HighlightedLine;
    this._highlightedLine.userData.containerType = EContainerType.noIntersectable;
    // 轮廓线会被挂进 wall/window/column 这些在 intersectableGroup 下的 model，
    // noIntersectable 只是让命中结果被丢弃，图层则让射线根本不去测这条 Line2
    this._highlightedLine.layers.set(ENTITY_LATER.HIGHLIGHT_LAYER);
  }

  get highlightedLine() {
    return this._highlightedLine;
  }

  setMaterial(material: LineMaterial) {
    this._highlightedLine.material.dispose();
    this._highlightedLine.material = material;
  }

  setHighlightedColor(color: number, lineWidth: number = 1) {
    const highlightedColor = new THREE.Color(color);
    this._highlightedLine.material.color = highlightedColor;
    this._highlightedLine.material.linewidth = lineWidth;
  }

  setVisible(visible: boolean) {
    this._highlightedLine.visible = visible;
  }

  dispose() {
    disposeAllChildrenThenRemoveFromParent(this._highlightedLine);
  }
}

export default HighlightedLine;
